// extracted by mini-css-extract-plugin
export default {"spinner":"styles_spinner__JftDf","grayColor":"styles_grayColor__v57Am","small":"styles_small__xVRRP"};